import http from '@/utils/api2'

const queryList = async (makeId) => {
  const res = await http.get(`/erp/make/charge/list`, { params: { makeId: makeId } })
  return res
}
const queryNames=async (makeId,name)=>{
  const res = await http.get(`/erp/make/charge/names/${makeId}`, { params: { name: name } })
  return res
}

const queryReport =async (makeId,orderId)=>{
  const res = await http.get(`/erp/make/charge/report`,{params:{makeId,orderId}})
  return res
}
export default {
  queryList,queryNames,queryReport
}
